export default [
  {
    path: '/settings/store-installer',
    name: 'settings-store-installer',
    component: () =>
      import(/* webpackChunkName: "settings" */
        /* webpackMode: "lazy" */
        `./views/StoreInstaller.vue`)
  },
  {
    path: '/settings',
    name: 'settings',
    component: () =>
      import(/* webpackChunkName: "settings" */
        /* webpackMode: "lazy" */
        `./views/Settings.vue`)
  },
  {
    path: '/settings/general',
    name: 'settings-general',
    component: () =>
      import(/* webpackChunkName: "settings" */
        /* webpackMode: "lazy" */
        `./views/SettingsGeneral.vue`)
  },
  {
    path: '/settings/languages',
    name: 'settings-languages',
    component: () =>
      import(/* webpackChunkName: "settings" */
        /* webpackMode: "lazy" */
        `./views/SettingsLanguages.vue`)
  },
  {
    path: '/settings/checkout',
    name: 'settings-checkout',
    component: () =>
      import(/* webpackChunkName: "settings" */
        /* webpackMode: "lazy" */
        `./views/SettingsCheckout.vue`)
  },
  {
    path: '/settings/taxes',
    name: 'settings-taxes',
    component: () =>
      import(/* webpackChunkName: "settings" */
        /* webpackMode: "lazy" */
        `./views/SettingsTaxes.vue`)
  },
  {
    path: '/settings/shipping',
    name: 'settings-shipping',
    component: () =>
      import(/* webpackChunkName: "settings" */
        /* webpackMode: "lazy" */
        `./views/SettingsShipping.vue`)
  },
  {
    path: '/settings/payment',
    name: 'settings-payment',
    component: () =>
      import(/* webpackChunkName: "settings" */
        /* webpackMode: "lazy" */
        `./views/SettingsPayment.vue`)
  },
  {
    path: '/settings/zones',
    name: 'settings-zone',
    component: () =>
      import(/* webpackChunkName: "settings" */
        /* webpackMode: "lazy" */
        `./views/SettingsZone.vue`)
  },
  {
    path: '/settings/customers',
    name: 'settings-customers',
    component: () =>
      import(/* webpackChunkName: "settings" */
        /* webpackMode: "lazy" */
        `./views/SettingsCustomers.vue`)
  },
  {
    path: '/settings/notifications',
    name: 'settings-notifications',
    component: () =>
      import(/* webpackChunkName: "settings" */
        /* webpackMode: "lazy" */
        `./views/SettingsNotifications.vue`)
  },
  {
    path: '/settings/plugins',
    name: 'settings-plugins',
    component: () =>
      import(/* webpackChunkName: "settings" */
        /* webpackMode: "lazy" */
        `./views/SettingsPlugins.vue`)
  }
]
